const additionalCollectionHandles = document
  .querySelector(".main-collection-container")
  ?.getAttribute("data-handles")
  .split(",");

function initializeLoadMore() {
  const mainCollectionGridItems = document.querySelectorAll(
    ".main-collection-grid"
  );
  console.log(`Found ${mainCollectionGridItems.length} main collection grid items.`);

  mainCollectionGridItems.forEach((gridItem) => {
    const button = gridItem.querySelector("button.loadMore");
    if (!gridItem || !button) return;

    button.addEventListener("click", function () {
      if (button.disabled) return;

      const url = button.getAttribute("data-url");
      const productGrid = gridItem.querySelector(".collection-product-list");

      if (url) {
        button.disabled = true;

        fetch(url)
          .then((response) => response.text())
          .then((html) => {
            const tempDiv = document.createElement("div");
            tempDiv.innerHTML = html;
            const products = tempDiv.querySelectorAll(
              ".collection-product-card"
            );
            products.forEach((product) => productGrid.appendChild(product));

            const nextPageButton = tempDiv.querySelector("button.loadMore");
            const nextUrl = nextPageButton?.getAttribute("data-url");

            if (nextPageButton && nextUrl) {
              button.setAttribute("data-url", nextUrl);
              button.disabled = false;
            } else {
              button.style.display = "none";
            }
          })
          .catch((error) => {
            console.error("Error fetching more products:", error);
            button.disabled = false;
          });
      } else {
        button.style.display = "none";
      }
    });
  });
  document.querySelector('.collection-product-count').innerText = document.querySelectorAll('.collection-product-card').length + " Results";
}

function fetchCollectionsSequentially(handles) {
  if (handles.length === 0) {
    console.log("All handles processed. Initializing loadMore.");
    initializeLoadMore();
   
    return;
  }

  const handle = handles.shift(); // Get the first handle and remove it from the list
  console.log(`Fetching handle: ${handle}`);

  fetch(handle)
    .then((response) => {
      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }
      return response.text();
    })
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const collectionGrid = doc.querySelector(".main-collection-grid");

      if (collectionGrid) {
        console.log("Collection grid found and fetched.");
        
        // Create a wrapper div for each fetched collection grid
        const wrapperDiv = document.createElement("div");
        wrapperDiv.className = "fetched-collection-grid";
        wrapperDiv.appendChild(collectionGrid);

        // Append the wrapper div to the container
        const collectionGridContainer = document.querySelector(
          ".collection-grid-section"
        );
        collectionGridContainer.appendChild(wrapperDiv);

        console.log("Appended collection grid:", collectionGrid); // Debug output
      } else {
        console.warn("No collection grid found for handle:", handle);
      }

      // Recursively fetch the next handle
      fetchCollectionsSequentially(handles);
    })
    .catch((error) => {
      console.error("Error fetching additional collection:", error);
      // Even if there's an error, continue with the next handle
      fetchCollectionsSequentially(handles);
    });
}

if (additionalCollectionHandles && additionalCollectionHandles.length > 0 && additionalCollectionHandles[0] !== "") {
  console.log("Starting fetch for handles.");
  fetchCollectionsSequentially([...additionalCollectionHandles]); // Start the sequential fetch
} else {
  console.log("No additional collections to fetch. Initializing loadMore.");
  initializeLoadMore();
}
